import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PricePipe } from "./price.pipe";


@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        PricePipe
    ],
    exports: [
        PricePipe
    ],
    providers: [
        PricePipe,
    ]
})
export class PricePipeModule { }
